import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { format, parseISO } from "date-fns";
import BlockUi from "react-block-ui";
import { calculationsTypes } from "../../../constants/calculationsTypes";

export default function Utilizacao(props) {
  const [loading, setLoading] = useState(true);
  const [features, setFeatures] = useState({});

  // o retorno não é usado no front, mas o POST tem efeito no servidor
  // (pode criar/renovar registro de assinatura) — não remover sem confirmar
  // o handler no jusfy-backend
  async function loadSubscription() {
    await axios.post(
      process.env.REACT_APP_API_URL + `/subscription/${props.cliente_id}`
    );
  }

  const getFeaturesUsage = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `/subscription/features/usage/${props.cliente_id}`
      );
      if (response.data) {
        setFeatures(response.data);
      } else {
        toast.error("Ocorreu um erro ao carregar as features.");
      }
      setLoading(false);
    } catch (err) {
      toast.error("Ocorreu um erro ao carregar as features.");
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    getFeaturesUsage();
    loadSubscription();
  }, []);

  return (
    <BlockUi tag="div" blocking={loading}>
      <h2>Cálculos</h2>
      <table className="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <th>Funcionalidade</th>
            <th>Quantidade</th>
            <th>Última vez</th>
          </tr>
        </thead>
        <tbody>
          {features.calculations &&
            features.calculations.map(feature => (
              <tr>
                <td>{calculationsTypes[feature.type]}</td>
                <td>{feature.count}</td>
                <td>
                  {format(parseISO(feature.last_usage), "dd/MM/yyyy HH:mm")}
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      <h2>Jurisprudências</h2>
      {features.jurisprudences && (
        <>
          <p>
            Quantidade:{" "}
            <label className="badge badge-info">
              {features.jurisprudences.count}
            </label>
          </p>
          <p>
            Última utilização:{" "}
            <label className="badge badge-info">
              {features.jurisprudences.last_usage !== null
                ? format(
                  parseISO(features.jurisprudences.last_usage),
                  "dd/MM/yyyy HH:mm"
                )
                : ""}
            </label>
          </p>
        </>
      )}

      <h2>Oportunidades</h2>
      {features.opportunities && (
        <>
          <p>
            Quantidade:{" "}
            <label className="badge badge-info">
              {features.opportunities.count}
            </label>
          </p>
          <p>
            Última utilização:{" "}
            <label className="badge badge-info">
              {features.opportunities.last_usage !== null
                ? format(
                  parseISO(features.opportunities.last_usage),
                  "dd/MM/yyyy HH:mm"
                )
                : ""}
            </label>
          </p>
        </>
      )}

      <h2>Consultas Jusfinder</h2>
      {features.queries && (
        <>
          <p>
            Quantidade:{" "}
            <label className="badge badge-info">{features.queries.count}</label>
          </p>
          <p>
            Última utilização:{" "}
            <label className="badge badge-info">
              {features.queries.last_usage !== null
                ? format(
                  parseISO(features.queries.last_usage),
                  "dd/MM/yyyy HH:mm"
                )
                : ""}
            </label>
          </p>
        </>
      )}

      <h2>Assinador de documentos</h2>
      {features.signatures && (
        <>
          <p>
            Quantidade:{" "}
            <label className="badge badge-info">
              {features.signatures.count}
            </label>
          </p>
          <p>
            Última utilização:{" "}
            <label className="badge badge-info">
              {features.signatures.last_usage !== null
                ? format(
                  parseISO(features.signatures.last_usage),
                  "dd/MM/yyyy HH:mm"
                )
                : ""}
            </label>
          </p>
        </>
      )}

      <h2>Agenda</h2>
      {features.schedule && (
        <>
          <p>
            Quantidade:{" "}
            <label className="badge badge-info">
              {features.schedule.count}
            </label>
          </p>
          <p>
            Última utilização:{" "}
            <label className="badge badge-info">
              {features.schedule.last_usage !== null
                ? format(
                  parseISO(features.schedule.last_usage),
                  "dd/MM/yyyy HH:mm"
                )
                : ""}
            </label>
          </p>
        </>
      )}
    </BlockUi>
  );
}
